
import { Options } from "vue-class-component";
import NodesConfigMixins from "../NodesConfigMixins";
@Options({
    name: "flowable-nodes-delay-node-config",
})
export default class DelayNodeConfig extends NodesConfigMixins {}
